import React, { useState, useEffect } from 'react'
import axios from '../../api/api';
import { toast } from 'sonner';

const Profile = () => {

  const [first_name, setFirst_Name] = useState('');
  const [last_name, setLast_Name] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [old_password, setOld_Password] = useState('');
  const [new_password, setNew_Password] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  // user details
  const currentUser = window.localStorage.getItem('token');
  const id = JSON.parse(currentUser).data.user_data.id;

  useEffect(() => {
    const getUser = async () => {
      try {
        const response = await axios.get(`/users/${id}`)
        setFirst_Name(response.data.first_name)
        setLast_Name(response.data.last_name)
        setEmail(response.data.email)
        setPhone(response.data.phone)
      } catch (error) {
        console.log(error)
      }
    }
    getUser()
  },[id])

  // update user profile
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (new_password.length < 8) {
      toast.error('Password must have a minimum of 8 characters')
      return
    }
    if (new_password !== confirmPassword) {
      toast.error('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await axios.put(`/users/profile/${id}`,
        { first_name, last_name, old_password, new_password }
      );
      toast.success('Profile updated successfully!');
      setTimeout(() => {
        window.location.reload()
      }, 1000);
    } catch (error) {
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else {
        toast.error('Error updating profile.');
      }
      console.log(error);
    } finally{
      setLoading(false)
    }
  };

  return (
    <div className='mx-auto p-4'>
      <div className='p-4 bg-white rounded-lg'>
        <h3 className='text-xl text-center font-bold text-[#134463]'>My Profile.</h3>
        <form onSubmit={handleSubmit}>
          <div className='mt-2'>
            <label htmlFor='fullname'>First Name
              <input
                type='text'
                required
                placeholder='First Names'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                value={first_name}
                onChange={(e) => setFirst_Name(e.target.value)}
              />
            </label>
          </div>
          <div className='mt-2'>
            <label htmlFor='fullname'>Last Name
              <input
                type='text'
                required
                placeholder='Last Names'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                value={last_name}
                onChange={(e) => setLast_Name(e.target.value)}
              />
            </label>
          </div>
          <div className='mt-2'>
            <label htmlFor='fullname'>Email
              <input
                type='text'
                required
                disabled
                placeholder='Email Address'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
          </div>
          <div className='mt-2'>
            <label htmlFor='phone'>Phone Number
              <input
                type='number'
                required
                disabled
                placeholder='07000000'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </label>
          </div>
          <div className='mt-2'>
            <label htmlFor='old Password'>Old Password
              <input
                type='new_password'
                placeholder='Old Password'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                value={old_password}
                onChange={(e) => setOld_Password(e.target.value)}
              />
            </label>
          </div>
          <div className='mt-2'>
            <label htmlFor='Password'>Password <i className='text-red-500'>(Min 8 characters)</i>
              <input
                type='new_password'
                placeholder='Password'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                value={new_password}
                onChange={(e) => setNew_Password(e.target.value)}
              />
            </label>
          </div>
          <div className='mt-2'>
            <label htmlFor='confirm Password'>Confirm New Password
              <input
                type='new_password'
                placeholder='Confirm Password'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </label>
          </div>
          <div className='py-3'>
            <button type='submit' disabled={loading} className='bg-[#2b1e3e] text-white px-5 py-1 w-full rounded-md hover:bg-[#134463]'>{loading ? 'Please wait...' : 'Update Profile'}</button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Profile
